/**
 * Created by RKL on 21/08/2015.
 */
define('personalizeMainRouter',[
  'require',
  'exports',
  'module',
  'logger',
  'marionette',
  'app'
], function(
  require,
  exports,
  module,
  Logger,
  Marionette,
  App
) {
  'use strict';

  var PersonalizeRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'personalize': 'showView'
    }
  });

  var API = {
    showView: function() {
      require([
        'personalizeShowController',
        'contentShowController'
      ], function(ShowController, ContentShowController) {
        ContentShowController.showContent().done(function() {
          App.startSubModule('personalizeMain');
          ShowController.showPersonalize();
          App.execute('set:active:nav:item', 'personalize');
        });
      });
    }
  };

  App.on('personalize:show', function() {
    App.navigate('personalize');
    API.showView();
  });

  App.on('before:start', function() {
    new PersonalizeRouter({
      controller: API
    });
  });

  module.exports = PersonalizeRouter;
});
